/** ***********************************************************************
 *
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2019 Adobe Systems Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe Systems Incorporated and its suppliers,
 * if any.  The intellectual and technical concepts contained
 * herein are proprietary to Adobe Systems Incorporated and its
 * suppliers and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe Systems Incorporated.
 ************************************************************************* */

import {
    CONFIRMATION_BOX_BTN_IDS,
} from './confirmationDialogConstants';
import CONFIRMATION_CTAS_REPO from './confirmationDialogActionsRepo';
import {
    AppDialogAction, AppDialogDescription,
} from '../../../../stores/dialog';
import { APP_DIALOG } from '../../../enums';
import TranslationUtil from '../../../translation';

class UninstallModelMapper {
    updateDialogRepo(appData) {
        const { confirmationDetails } = appData;
        const heading = TranslationUtil.getMessage('ccx.confirmation.uninstall.title', { appName: appData.display_name }); // this will be upadated through react-intl passing the appName.
        const description = [
            new AppDialogDescription(APP_DIALOG.DESCRIPTION_TYPE.PARAGRAPH, TranslationUtil.getMessage('ccx.confirmation.uninstall.desc')),
        ];
        const actionList = [];

        confirmationDetails.confirmationButtons.map((btnInConfirmationBox) => {
            if (!btnInConfirmationBox.id) {
                return null;
            }
            switch (btnInConfirmationBox.id.toLowerCase()) {
            case CONFIRMATION_BOX_BTN_IDS.PRIMARY:
                actionList.push(new AppDialogAction({
                    localizedText: TranslationUtil.getMessage('ccx.confirmation.uninstall.btn.keepPreferences'),
                    ariaLabel: 'Keep Preferences',
                    ...CONFIRMATION_CTAS_REPO[CONFIRMATION_BOX_BTN_IDS.PRIMARY],
                }));
                break;
            case CONFIRMATION_BOX_BTN_IDS.SECONDARY:
                actionList.push(new AppDialogAction({
                    localizedText: TranslationUtil.getMessage('ccx.confirmation.uninstall.btn.removePreferences'),
                    ariaLabel: 'Remove Preferences',
                    ...CONFIRMATION_CTAS_REPO[CONFIRMATION_BOX_BTN_IDS.SECONDARY],
                }));
                break;
            case CONFIRMATION_BOX_BTN_IDS.TERTIARY:
                actionList.push(new AppDialogAction({
                    localizedText: TranslationUtil.getMessage('ccx.confirmation.btn.cancel'),
                    ariaLabel: 'Cancel',
                    ...CONFIRMATION_CTAS_REPO[CONFIRMATION_BOX_BTN_IDS.TERTIARY],
                }));
                break;
            default:
                break;
            }
            return null;
        });
        return {
            heading, description, actionList,
        };
    }
}
export default new UninstallModelMapper();
